<app-date-picker
	label="Requisition Date"
	[ngModel]="titleSearchCompletionDate$ | async"
	(ngModelChange)="onChange($event)"
	orientation="row"
	[skeletonLoading]="skeletonLoading"
	(focus)="_onFocus()"
	[labelIcon]="AI_ICON"
	[labelToolTip]="
		(titleSearchCompletionDateFieldMapping$ | async) ? AI_TOOLTIP : ''
	"
	[labelIconClasses]="AI_CLASSES"
	[maxDate]="closingDate$ | async"
	maxDateErrorLabel="Closing Date"
	[testHook]="testHooks.TitleSearchCompletionDatePicker"
/>
